export class ChangePassword {
  oldPassword: string;
  newPassword: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/change-password.ts